<template>
  <div class="activity-library-table__container" id="activity-library-table__container">
    <div class="container mt-30">
      <div class="card m-b-30">
        <div class="card-body">
          <div class="d-flex justify-content-between pl-15 pt-15 pb-10 pr-5">
            <h4 class="mt-0 header-title" v-if="title.toLowerCase() == 'drafts' || title.toLowerCase() == 'activities' || title.toLowerCase() == 'archived'">
              {{ title | lowercase | capitalize }}
              <span class="badge badge-secondary ml-5">{{ count }}</span>
            </h4>
            <h4 class="mt-0 header-title" v-else-if="title.toLowerCase() == 'active'">
              Active (Awaiting Publish)
              <span class="badge badge-secondary ml-5">{{ count }}</span>
            </h4>
            <h4 class="mt-0 header-title" v-else>
              {{ title }}
              <span class="badge badge-secondary ml-5">{{ count }}</span>
            </h4>
            <div v-if="isDisplayViews && previewSelectedId == null">
              <span :class="{ 'active-view': currentView === viewsImages[0].view }" @click="changeView(viewsImages[0].view)">
                <img v-if="currentView === viewsImages[0].view" :src="viewsImages[0].selectedsrc" class="activity-library-table__view-img" />
                <img v-else :src="viewsImages[0].src" class="activity-library-table__view-img" />
              </span>
              <span :class="{ 'active-view': currentView === viewsImages[1].view }" @click="changeView(viewsImages[1].view)">
                <img v-if="currentView === viewsImages[1].view" :src="viewsImages[1].selectedsrc" class="activity-library-table__view-img" />
                <img v-else :src="viewsImages[1].src" class="activity-library-table__view-img" />
              </span>
            </div>
          </div>

          <template v-if="isDisplayTable && count > 0">
            <BaseTable @onSortColumn="onSortColumn" :data="data" :columnNames="currentViewColumns" :columnMetaData="columnMetaData" :previewSelectedId="previewSelectedId" :viewMode="viewMode" :tableType="tableType" :migrationData="migrationData">
              <template :slot="ALL_COLUMN_NAMES.PIN" slot-scope="{ data }">
                <img v-if="data.row[ALL_COLUMN_NAMES.PIN] === 1" src="static/img/activity-configurator/activity-library-table-selected-pin.svg" height="20" class="cursor-pointer" @click="onUnpinActivity(data.row.id, data.row.activityId, data.row.revisionId)" />
                <img v-else src="static/img/activity-configurator/activity-library-table-not-selected-pin.svg" height="20" class="cursor-pointer" @click="onPinActivity(data.row.id, data.row.activityId, data.row.revisionId)" />
              </template>

              <template :slot="ALL_COLUMN_NAMES.EMPTY_PIN">
                <div class="activity-library-table__empty-pin"></div>
              </template>

              <template :slot="ALL_COLUMN_NAMES.PREVIEW" slot-scope="{ data }">
                <img v-if="previewSelectedId === data.row.id" src="static/img/surveyPreview/show.png" class="cursor-pointer" @click="previewActivity(data.row)" alt />
                <img v-else src="static/img/surveyPreview/hide.png" class="cursor-pointer" @click="previewActivity(data.row)" alt />
              </template>
              <template :slot="ALL_COLUMN_NAMES.STUDIES" slot-scope="{ data }">
                <div class="badge-container va-m">
                  <span class="activity-library-table__language-box" :id="`${title}-${data.row.id}-study`" tabindex="0" @click="sortStudyArray(data.row)">{{ (data.row.studies && data.row.studies.length) || 0 }}</span>
                  <b-popover :target="`${title}-${data.row.id}-study`" triggers="click blur" placement="left" container="activity-library-table__container">
                    <div class="activity-library-table__language-pop-over-container" v-if="data.row.studies && data.row.studies.length">
                      <ul class="activity-library-table__languages-list">
                        <li class="activity-library-table__languages-list-item" v-for="(study, index) in sortedStudies" :key="index">
                          {{ study }}
                        </li>
                      </ul>
                    </div>
                  </b-popover>
                </div>
              </template>
              <template :slot="ALL_COLUMN_NAMES.VERSION" slot-scope="{ data }">
                <div class="va-m">
                  <span class="m-0" v-if="data.row.version" :id="`${title}-${data.row.id}-version`">Version&nbsp;{{ data.row.version }} </span>
                </div>
              </template>
              <template :slot="ALL_COLUMN_NAMES.INSTANCES" slot-scope="{ data }">
                <div class="va-m" v-if="data.row.migrationCount">
                  <span class="m-0">{{ data.row.migrationCount }} </span>
                </div>
              </template>
              <template :slot="ALL_COLUMN_NAMES.LANGUAGE" slot-scope="{ data }">
                <div class="badge-container va-m">
                  <span class="activity-library-table__language-box" :id="`${title}-${data.row.id}-language`" tabindex="0" @click="sortArray(data.row[ALL_COLUMN_NAMES.LANGUAGE])">{{ (data.row[ALL_COLUMN_NAMES.LANGUAGE] && data.row[ALL_COLUMN_NAMES.LANGUAGE].length) || 0 }}</span>
                  <b-popover :target="`${title}-${data.row.id}-language`" triggers="click blur" placement="left" container="activity-library-table__container">
                    <div class="activity-library-table__language-pop-over-container" v-if="data.row[ALL_COLUMN_NAMES.LANGUAGE] && data.row[ALL_COLUMN_NAMES.LANGUAGE].length">
                      <ul class="activity-library-table__languages-list">
                        <li class="activity-library-table__languages-list-item" v-for="(language, index) in sortedLanguages" :key="index">
                          {{ language }}
                        </li>
                      </ul>
                    </div>
                  </b-popover>
                </div>
              </template>

              <template :slot="ALL_COLUMN_NAMES.LAST_MODIFIED" slot-scope="{ data }">
                <p class="m-0">
                  {{ data.row[ALL_COLUMN_NAMES.LAST_MODIFIED] | formatDate }}
                </p>
              </template>

              <template :slot="ALL_COLUMN_NAMES.TAGS" slot-scope="{ data }">
                <div class="badge-container va-m mt-3 row" v-if="data.row[ALL_COLUMN_NAMES.TAGS] != undefined">
                  <div class="tag2_div">
                    <span v-for="tag in sortTagsArray(data.row[ALL_COLUMN_NAMES.TAGS], 0, 2)" :key="tag" class="activity-library-table__chip mr-5">{{ tag }}</span>
                  </div>
                  <div class="plus_div">
                    <span v-if="data.row[ALL_COLUMN_NAMES.TAGS] && data.row[ALL_COLUMN_NAMES.TAGS].length > 2" class="activity-library-table__language-box fs-12 h-21 w-21" tabindex="0" :id="`${title}-${data.row.id}-tags`">
                      <i class="fa fs-10 fa-plus" aria-hidden="true"></i>
                    </span>
                    <b-popover v-if="data.row[ALL_COLUMN_NAMES.TAGS] && data.row[ALL_COLUMN_NAMES.TAGS].length > 2" :target="`${title}-${data.row.id}-tags`" triggers="click blur" placement="right" container="activity-library-table__container">
                      <div class="activity-library-table__language-pop-over-container">
                        <ul class="activity-library-table__languages-list">
                          <li v-for="tag in sortTagsArray(data.row[ALL_COLUMN_NAMES.TAGS], 2, data.row[ALL_COLUMN_NAMES.TAGS].length)" :key="tag" class="activity-library-table__languages-list-item">
                            {{ tag }}
                          </li>
                        </ul>
                      </div>
                    </b-popover>
                  </div>
                </div>
              </template>

              <template v-if="previewSelectedId == null" :slot="ALL_COLUMN_NAMES.ACTION" slot-scope="{ data }">
                <div class="dropleft">
                  <img src="static/img/activity-configurator/row-settings.svg" id data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" alt class="activity-library-table__action-icon dropdown-toggle" v-if="viewMode == false || tableType == 'Archived'" />
                  <span v-if="viewMode == true" class="back_link" v-on:click="addActivityToStudy(data.row)">
                    <i class="fa fa-angle-right" style="font-size: 24px" aria-hidden="true" />
                  </span>
                  <ul class="dropdown-menu action-dropdown-menu p-0 dropleft" v-if="tableType == 'Drafts'">
                    <li class="border-bottom settings-dropdown-item fs-12" :class="getlibraryAccess()">
                      <span @click.stop="goToActivityEdit(data.row, 'activity-details')" class="dropdown-item pl-0">Edit</span>
                    </li>
                    <li class="dropdown-submenu border-bottom settings-dropdown-item d-flex fs-12">
                      <img src="static/img/activity-configurator/arrow-left.svg" class="export_img" alt />
                      <span class="dropdown-item dropdown-toggle pl-0">Export</span>
                      <ul class="dropdown-menu fs-12">
                        <li class="border-bottom fs-12">
                          <span @click="downloadObjectAsJson(data.row.id, undefined)" class="dropdown-item pl-10">Export JSON</span>
                        </li>
                        <li>
                          <span @click="exportPdf(data.row.id, undefined)" class="dropdown-item pl-10">Export PDF</span>
                        </li>
                      </ul>
                    </li>
                    <li href="#" class="border-bottom settings-dropdown-item fs-12">
                      <span @click.stop="deleteActivity(data.row.id)" class="dropdown-item pl-0">Delete</span>
                    </li>
                  </ul>
                  <ul class="dropdown-menu action-dropdown-menu p-0 dropleft" v-if="tableType == 'Active'">
                    <li class="border-bottom settings-dropdown-item fs-12" :class="getlibraryAccess()">
                      <span @click.stop="reviseActivity(data.row, 'activity-details')" class="dropdown-item pl-0">Revise</span>
                    </li>
                    <li class="border-bottom settings-dropdown-item fs-12">
                      <span @click.stop="createActivityCopy(data.row, 'activity-details')" class="dropdown-item pl-0">Create copy</span>
                    </li>
                    <li href="#" class="border-bottom settings-dropdown-item fs-12" :class="getlibraryAccess()">
                      <span @click.stop="archiveActivity(data.row.activityId, data.row.revisionId)" class="dropdown-item pl-0">Archive</span>
                    </li>
                    <li href="#" class="border-bottom settings-dropdown-item fs-12">
                      <span @click.stop="getActivityVersions(data.row.activityId)" class="dropdown-item pl-0">Versions </span>
                    </li>
                    <li class="dropdown-submenu border-bottom settings-dropdown-item d-flex fs-12">
                      <img src="static/img/activity-configurator/arrow-left.svg" class="export_img" alt />
                      <span class="dropdown-item dropdown-toggle pl-0">Export</span>
                      <ul class="dropdown-menu fs-12">
                        <li class="border-bottom fs-12">
                          <span @click="downloadObjectAsJson(data.row.activityId, data.row.revisionId)" class="dropdown-item pl-10">Export JSON</span>
                        </li>
                        <li>
                          <span @click="exportPdf(data.row.activityId, data.row.revisionId)" class="dropdown-item pl-10">Export PDF</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <ul class="dropdown-menu action-dropdown-menu p-0 dropleft" v-if="tableType == 'Published' && viewMode == false">
                    <li class="border-bottom settings-dropdown-item fs-12" :class="getlibraryAccess()" v-if="!data.row.isMigrated">
                      <span @click.stop="reviseActivity(data.row, 'activity-details')" class="dropdown-item pl-0">Revise</span>
                    </li>
                    <li class="border-bottom settings-dropdown-item fs-12">
                      <span @click.stop="createActivityCopy(data.row, 'activity-details')" class="dropdown-item pl-0">Create copy</span>
                    </li>
                    <li href="#" class="border-bottom settings-dropdown-item fs-12" :class="getlibraryAccess()">
                      <span @click.stop="archiveActivity(data.row.activityId, data.row.revisionId)" class="dropdown-item pl-0">Archive</span>
                    </li>
                    <li href="#" class="border-bottom settings-dropdown-item fs-12">
                      <span @click.stop="getActivityVersions(data.row.activityId)" class="dropdown-item pl-0">Versions</span>
                    </li>
                    <li class="dropdown-submenu border-bottom settings-dropdown-item d-flex fs-12">
                      <img src="static/img/activity-configurator/arrow-left.svg" class="export_img" alt />
                      <span class="dropdown-item dropdown-toggle pl-0">Export</span>
                      <ul class="dropdown-menu fs-12">
                        <li class="border-bottom fs-12">
                          <span @click="downloadObjectAsJson(data.row.activityId, data.row.revisionId)" class="dropdown-item pl-10">Export JSON</span>
                        </li>
                        <li>
                          <span @click="exportPdf(data.row.activityId, data.row.revisionId)" class="dropdown-item pl-10">Export PDF</span>
                        </li>
                      </ul>
                    </li>
                    <li v-if="migrationData && !migrationData.threadLibrary && migrationData.activityMigration && user.userRole == 'SystemAdmin'" class="dropdown-submenu border-bottom settings-dropdown-item d-flex fs-12">
                      <img src="static/img/activity-configurator/arrow-left.svg" class="export_img" alt />
                      <span class="dropdown-item pl-0"> &nbsp;Migrate to</span>
                      <ul class="dropdown-menu fs-12">
                        <li
                          class="border-bottom fs-12"
                          @click.stop="
                            moveToThreadLibrary({
                              revisionId: data.row.revisionId,
                              targetLibrary: targetLibrary
                            })
                          "
                        >
                          <span class="dropdown-item pl-10">THREAD Library</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <ul class="dropdown-menu action-dropdown-menu p-0 dropleft" v-if="tableType == 'Archived'">
                    <li class="border-bottom settings-dropdown-item fs-12">
                      <span @click.stop="createActivityCopy(data.row, 'activity-details')" class="dropdown-item pl-0">Create copy</span>
                    </li>
                    <li class="dropdown-submenu border-bottom settings-dropdown-item d-flex fs-12">
                      <img src="static/img/activity-configurator/arrow-left.svg" class="export_img" alt />
                      <span class="dropdown-item dropdown-toggle pl-0">Export</span>
                      <ul class="dropdown-menu fs-12">
                        <li class="border-bottom fs-12">
                          <span @click="downloadObjectAsJson(data.row.activityId, data.row.revisionId)" class="dropdown-item pl-10">Export JSON</span>
                        </li>
                        <li>
                          <span @click="exportPdf(data.row.activityId, data.row.revisionId)" class="dropdown-item pl-10">Export PDF</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <div class="dropdown-menu action-dropdown-menu p-0 dropleft" v-if="title && title.toLowerCase() !== 'drafts' && viewMode == true"></div>
                </div>
              </template>
            </BaseTable>
          </template>

          <template v-else>
            <div class="text-center fs-16 mb-15 font-weight-bold">
              No available activities
            </div>
          </template>
        </div>

        <div v-if="showCollapseRow" class="d-flex justify-content-center align-items-center">
          <span @click="toggleCollapseState" class="activity-library-table__collapse-state-text d-flex">
            <template v-if="isCollapsed">
              Expand
              <img src="static/img/activity-configurator/arrow-down-blue.png" class="activity-library-table__expand-arrow" alt />
            </template>
            <template v-else>
              Collapse
              <img src="static/img/activity-configurator/arrow-down-blue.png" class="activity-library-table__collapse-arrow" style="transform: rotateX(180deg)" alt />
            </template>
          </span>
        </div>

        <div class="row display-inline-flex activity-library-table__pagination" v-if="isPaginate && count > 0">
          <div class="arrow-icon cursor_pointer" @click="onPageChange(-1)">
            <i class="fa fa-angle-left fs-23 pt-3"></i>
          </div>
          <div class="pagination pt-3">
            {{ pagination && pagination.current + 1 }}
          </div>
          <div class="pagination2 pt-3">of {{ pagination && pagination.total }}</div>
          <div class="arrow-icon pt-3 cursor_pointer" @click="onPageChange(1)">
            <i class="fa fa-angle-right fs-23"></i>
          </div>
        </div>
      </div>
    </div>

    <template v-if="isDataFetching">Loading.....</template>
    <b-modal ref="activityVersionsModal" :hide-header="true" :hide-footer="true" size="lg" :body-class="['p-0']" class="versions-modal" scrollable :no-close-on-backdrop="true">
      <div class="versions-modal__container p-25">
        <span class="version_heading">Versions</span>
        <img src="static/img/add.svg" class="rt-2-10 close-icon" @click="closeActivityVersionsModal" />
        <table class="table">
          <thead class="fs-12">
            <tr>
              <th class="border-top-0 version_width" scope="col">Number</th>
              <th class="border-top-0" scope="col">Comments</th>
              <th class="border-top-0" scope="col">Saved Date</th>
              <th class="border-top-0" scope="col">Modified By</th>
              <th class="border-top-0" scope="col" v-if="title.toLowerCase() === 'activities'">
                <span>Modifications</span>
              </th>
              <th class="border-top-0" scope="col">Version Status</th>
              <th class="border-top-0" scope="col" v-if="migrationData && migrationData.threadLibrary && migrationData.activityMigration">
                <span>Instances</span>
              </th>
              <th class="border-top-0" scope="col">
                <span v-if="migrationData && migrationData.threadLibrary && migrationData.activityMigration"></span>
              </th>
            </tr>
          </thead>
          <tbody :class="this.overallactivityRevisionCount < 10 ? 'tbody.table-scroller' : 'versions-modal .table tbody'">
            <tr v-for="(revision, index) in activityRevisions" :key="index" :class="revision.status == 'Published' ? 'table-secondary' : ''">
              <th class="border-top-0 version_width" scope="row">
                {{ revision.version }}
              </th>
              <th class="border-top-0" scope="col">{{ revision.comment }}</th>
              <th class="border-top-0" scope="col">
                {{ revision.modifiedTime | formatDate }}
              </th>
              <th class="border-top-0" scope="col">
                {{ revision.modifiedBy }}
              </th>
              <th class="table-bordered border-top-0" scope="col" v-if="title.toLowerCase() === 'activities'">
                <div>
                  <button v-if="revision.status !== 'Published'" type="button" class="btn btn-default mr-6" @click="openActivityComparator(revision)">
                    View Modifications
                  </button>
                </div>
              </th>
              <th class="table-bordered border-top-0" scope="col">
                <div v-if="revision.status == 'Published'">
                  <span class="badge badge-light table-bordered">Live</span>
                </div>
                <div v-else-if="migrationData && migrationData.threadLibrary && migrationData.activityMigration == true && index < 1">
                  <span class="badge badge-light table-bordered">Live</span>
                </div>
              </th>
              <th class="border-top-0" scope="col" v-if="(migrationData && migrationData.threadLibrary && migrationData.activityMigration == true) || (title.toLowerCase() === 'activities' && migrationData && migrationData.threadLibrary)">
                <div v-if="migrationData && migrationData.threadLibrary && migrationData.activityMigration == true">
                  <div class="badge-container va-m">
                    <span class="activity-library-table__language-box" tabindex="0" :id="'popover1' + index" v-if="revision && revision.migrationCount">{{ revision.migrationCount }}</span>
                    <b-popover :target="'popover1' + index" triggers="hover blur" placement="left" container="activity-library-table__container" v-if="revision && revision.migratedInstances">
                      <div class="activity-library-table__language-pop-over-container" v-for="(migratedInstance, mIndex) in instanceSort(revision.migratedInstances)" :key="mIndex">
                        <ul class="activity-library-table__languages-list p-0 mb-0 pl-5">
                          <li class="activity-library-table__languages-list-item">
                            {{ migratedInstance.clientName }}
                          </li>
                        </ul>
                      </div>
                    </b-popover>
                  </div>
                </div>
              </th>
              <th class="table-bordered border-top-0" scope="col">
                <button v-if="(revision.status == 'Active' || revision.status == 'Inactive') && !revision.isMigrated" type="button" class="btn btn-default mr-6" v-on:click="createDraft(revision)" :disabled="title.toLowerCase() === 'activities' && revision.isMigrated">
                  Create Draft
                </button>
                <button v-if="revision.status == 'Active' || revision.status == 'Inactive'" type="button" class="btn btn-default" v-on:click="markAsPublished(revision)">
                  Publish
                </button>
                <button v-if="revision.status == 'Published' && migrationData && migrationData.threadLibrary && migrationData.activityMigration == true" type="button" class="btn btn-default" v-on:click="confirmMigrateToInstance(revision)">
                  Migrate to Instance
                </button>
              </th>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
    <b-modal id="addNewInstanceModal" class="migratepopup" size="xl" ref="addNewInstanceModal" @hidden="onClose" hide-footer title="Migrate to instance">
      <div class="multiselect filter-form-box" id="languageSelectBox" ref="instances-select">
        <div class="selectBox" @click="showCheckboxesInstance">
          <label class="input" id="select-instance">
            <input class="activity-type-select input__field language-search-bar" type="text" placeholder="Search Instances" v-model="searchedInstance" @change="showCheckboxesInstance()" />
            <span class="input__label">Search Instances</span>
          </label>
        </div>
        <div id="showCheckboxesInstance" class="select-scroll activity-builder-select-options search-instance" v-if="isDisplayInstancesCheckBoxes">
          <div class="check_label_input d-flex" v-for="instance in searchedInstancesList" :key="instance.id">
            <input :id="instance.id" :disabled="revisionDataVersion.migratedInstances.some(item => item.clientId === instance.id)" @click="onChangeInstanceFilter(instance)" type="checkbox" :checked="isInstanceSelected(instance.id)" />
            <label :for="instance.id">{{ instance.name | toUpperCase }}</label>
          </div>
        </div>
        <button :disabled="selectInstance.length > 0 ? false : true" :style="selectInstance.length > 0 ? 'background-color:#4c8ce4; color:#fff' : 'false'" type="button" class="migratebtn" @click="createMigration()">
          Migrate
        </button>
      </div>
    </b-modal>

    <b-modal ref="comparatorModal" size="1162" class="activity-comparator" scrollable :hide-footer="true" :hide-header="true" :no-close-on-backdrop="true">
      <header class="modal-header fs-16 bb-none text-black pl-0 pr-0 pt-0">
        <span class="modal-title">Modifications</span>
        <button type="button" class="close text-color" @click="closeComparatorModal">
          <i class="fa fa-times"></i>
        </button>
      </header>
      <comparator :source-activity-data="sourceActivityData" :target-activity-data="targetActivityData" :load-differences="loadActivityDiff" :hide-push-to-live="true" />
    </b-modal>
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import toastr from "toastr";
import { AclRule } from "vue-acl";
import filter from "lodash/filter";
import swal from "sweetalert2";
import BaseTable from "@/components/activity-library/base-table";
import * as ALL_COLUMN_NAMES from "@/constants/activity-library-and-configurator-component/column-names";
import columnMetaData from "@/constants/activity-library-and-configurator-component/column-meta-data";
import studyActivityCommon from "@/components/configurator/study-activities-mixin";
import { mapGetters } from "vuex";
import Comparator from "@/components/activity-library/activity-comparator/comparator";

export default {
  name: "ActivityLibraryTable",

  data() {
    return {
      ALL_COLUMN_NAMES,
      columnMetaData,
      overallactivityRevisionCount: "",
      userProfileData: false,
      sortedStudies: [],
      sortedLanguages: [],
      viewsImages: [
        {
          view: 1,
          src: "static/img/activity-configurator/activities-list-view-1.png",
          selectedsrc: "static/img/activity-configurator/activities-list-selected-view-1.png"
        },
        {
          view: 2,
          src: "static/img/activity-configurator/activities-list-view-2.png",
          selectedsrc: "static/img/activity-configurator/activities-list-selected-view-2.png"
        }
      ],
      activityRevisions: null,
      listOfInstances: [],
      isDisplayInstancesCheckBoxes: false,
      eventListenerToHideLanguageDropdown: null,
      searchedInstance: "",
      instancesFilter: [],
      revisionDataVersion: null,
      targetLibrary: "Thread",
      selectInstance: [],
      loadActivityDiff: false,
      sourceActivityData: null,
      targetActivityData: null
    };
  },
  mixins: [studyActivityCommon],
  components: {
    BaseTable,
    Comparator
  },
  props: {
    previewSelectedId: null,
    isDisplayTitle: {
      type: Boolean,
      default: true,
      required: false
    },
    migrationData: { type: Object },
    count: {},
    title: {
      type: String,
      required: false
    },
    data: {},
    isDataFetching: {
      type: Boolean,
      default: false,
      required: false
    },
    viewMode: {
      type: Boolean,
      default: false
    },
    studyId: null,
    numberOfViews: {
      type: Number,
      default: 2,
      required: false
    },
    activitiesCount: {
      type: Number,
      required: false
    },
    showCollapseRow: {
      type: Boolean,
      required: false,
      default: false
    },
    isCollapsed: {
      type: Boolean,
      required: false
    },
    isDisplayViews: {
      type: Boolean,
      required: false,
      default: false
    },
    currentView: {
      type: Number,
      required: true,
      default: 1
    },
    displayPinColumn: {
      type: Boolean,
      required: false,
      default: true
    },
    isPaginate: {
      type: Boolean,
      default: true,
      required: false
    },
    pagination: {},
    views: {},
    tableType: {
      default: ""
    }
  },

  filters: {
    formatDate(value) {
      return moment(value).format("DD MMM YYYY hh:mm A z");
    },
    toUpperCase(v) {
      if (!v) {
        return "";
      }
      return v.charAt(0).toUpperCase() + v.slice(1);
    }
  },
  computed: {
    ...mapGetters(["user"]),
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    isDisplayTable() {
      return true;
    },
    currentViewColumns() {
      const view = this.currentView;
      return this.views[view];
    },
    tableTitle() {
      if (this.data.title) {
        return this.data.title;
      }
      return "";
    },
    searchedInstancesList() {
      if (!this.listOfInstances) {
        return [];
      }
      if (!this.listOfInstances.length) {
        return [];
      }
      const listOfInstances = this.listOfInstances.filter(instance => instance.name.toLowerCase().includes(this.searchedInstance.toLowerCase()));
      return listOfInstances.sort((a, b) => a.name.localeCompare(b.name));
    }
  },
  destroyed() {
    document.removeEventListener("click", this.eventListenerToHideLanguageDropdown);
  },
  watch: {
    searchedInstance(val) {
      if (val.length) {
        this.isDisplayInstancesCheckBoxes = true;
      } else {
        this.isDisplayInstancesCheckBoxes = false;
      }
    }
  },
  methods: {
    instanceSort(data) {
      data.forEach(item => {
        const name = item.clientName;
        item.clientName = name.charAt(0).toUpperCase() + name.slice(1);
      });
      return _.sortBy(data, "clientName");
    },
    createMigration() {
      this.$api
        .saveMigration(this.revisionDataVersion.activityId, {
          selectedClientIds: this.instancesFilter,
          activityId: this.revisionDataVersion.activityId,
          revisionId: this.revisionDataVersion.revisionId
        })
        .then(() => {
          this.instancesFilter = [];
          this.selectInstance = [];
          this.$refs.addNewInstanceModal.hide();
          setTimeout(() => {
            this.$emit("refreshActivityList", {});
          }, 2000);
          this.$toastr.success("Migration is currently in progress. This may take a few minutes.");
        })
        .catch(() => {
          this.$toastr.error("Could not migrate the activity");
        });
    },
    onChangeInstanceFilter(instance) {
      const optionIndex = this.instancesFilter.findIndex(element => element === instance.id);

      if (optionIndex === -1) {
        this.instancesFilter.push(instance.id);
      } else {
        this.instancesFilter.splice(optionIndex, 1);
      }
      const selected = this.selectInstance.findIndex(element => element === instance.id);

      if (selected === -1) {
        this.selectInstance.push(instance.id);
      } else {
        this.selectInstance.splice(selected, 1);
      }
    },
    isInstanceSelected(id) {
      return this.instancesFilter.findIndex(e => e === id) > -1;
    },
    hideLanguageCheckBox() {
      this.eventListenerToHideLanguageDropdown = document.addEventListener("click", event => {
        if (this.$refs["instances-select"] && this.$refs["instances-select"].contains(event.target)) {
        } else {
          this.isDisplayInstancesCheckBoxes = false;
          this.searchedInstance = "";
        }
      });
    },
    showCheckboxesInstance() {
      if (!this.isDisplayInstancesCheckBoxes) {
        this.isDisplayInstancesCheckBoxes = true;
      } else {
        this.isDisplayInstancesCheckBoxes = false;
      }
    },
    getActivtyThreadInstances() {
      this.$api.getThreadInstances().then(response => {
        const responseData = response.data.filter(item => item.name !== "Thread");
        this.listOfInstances = responseData.sort((a, b) => a.name.localeCompare(b.name));
      });
    },
    moveToThreadLibrary(payload) {
      this.$api
        .getActivitiesThreadLibrary(payload)
        .then(response => {
          if (response.data.status == "Success") {
            toastr.success("Activity moved to THREAD Library.");
          }
        })
        .catch(() => {
          this.$toastr.error("An error occurred while moving the activity to THREAD library.");
        });
    },
    getSortedVersionHistory(activityVersionHistory) {
      return _.sortBy(activityVersionHistory, [
        function(o) {
          return _.parseInt(o.version);
        }
      ]).reverse();
    },
    sortTagsArray(array, start, limit) {
      const slicedArray = start !== null && limit !== null ? array.slice(start, limit) : array;
      return _.orderBy(slicedArray, [tag => tag.toLowerCase()]);
    },
    sortArray(array) {
      this.sortedLanguages = array.sort();
    },
    sortStudyArray(array) {
      const map = array.studies.map(e => e.name);
      this.sortedStudies = map;
    },
    onSortColumn(columnName) {
      this.$emit("onSortColumn", columnName);
    },
    changeView(view) {
      this.$emit("changeView", view);
    },
    toggleCollapseState() {
      this.$emit("toggleCollapseState");
    },
    onPinActivity(id, activityId, revisionId) {
      const reqObj = { id, activityId, revisionId };
      this.$emit("onPinActivity", reqObj);
    },
    deleteActivity(activityId) {
      this.$emit("deleteActivity", activityId);
    },
    onUnpinActivity(id, activityId, revisionId) {
      const reqObj = { id, activityId, revisionId };
      this.$emit("onUnpinActivity", reqObj);
    },
    onPageChange(direction) {
      this.$emit("onPageChange", direction);
    },
    previewActivity(activity) {
      this.$emit("previewActivity", {
        activityId: this.tableType == "Drafts" ? activity.id : activity.activityId,
        id: activity.id,
        revisionId: activity.revisionId,
        previewSelectedId: this.previewSelectedId
      });
    },
    goToActivityEdit(row, path) {
      this.$router.push({
        name: path,
        params: { activityId: row.id }
      });
    },
    reviseActivity(row, path) {
      this.$router.push({
        name: path,
        params: {
          activityId: row.activityId,
          revisionId: row.revisionId,
          mode: "revise"
        },
        query: {
          revisionId: row.revisionId,
          mode: "revise"
        }
      });
    },
    createActivityCopy(row, path) {
      this.$router.push({
        name: path,
        params: {
          activityId: row.activityId,
          revisionId: row.revisionId,
          mode: "copy"
        },
        query: { revisionId: row.revisionId, mode: "copy" }
      });
    },
    editPublishedActivity(row, path) {
      this.$router.push({
        name: path,
        params: { activityId: row.activityId },
        query: {
          revisionId: row.revisionId,
          ispublished: 1
        }
      });
    },
    markAsPublished(revision) {
      swal({
        title: "Are you sure you would like to push this version live? This will replace the current version of this activity in the library.",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b8c7ce",
        cancelButtonColor: "#f16559",
        confirmButtonText: "Cancel",
        cancelButtonText: "Continue"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          this.$api
            .updateActivityStatus(revision.activityId, revision.revisionId, "Published")
            .then(() => {
              toastr.success("Activity version is live");
              this.$refs.activityVersionsModal.hide();
              this.$emit("refreshActivityList", {});
            })
            .catch(error => {
              this.errorMsg = error.body ? error.body.message : "Error while Published activity";
            });
        }
      });
    },
    confirmMigrateToInstance(revision) {
      swal({
        title: "Are you sure you would like to push this version live? This will replace the current version of this activity in the library.",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#f16559",
        cancelButtonColor: "#b8c7ce",
        confirmButtonText: "Continue",
        confirmButtonAriaLabel: "continue_btn_swal",
        cancelButtonText: "Cancel",
        cancelButtonAriaLabel: "cancel_btn_swal"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          //
        } else {
          // Show Migrate popup
          this.revisionDataVersion = revision;
          if (this.revisionDataVersion && this.revisionDataVersion.migratedInstances) {
            this.revisionDataVersion.migratedInstances.forEach(data => {
              this.instancesFilter.push(data.clientId);
            });
          }
          this.$refs.addNewInstanceModal.show();
        }
      });
    },
    onClose() {
      this.$refs.activityVersionsModal.hide();
    },
    createDraft(revision) {
      this.reviseActivity(revision, "activity-details");
    },
    archiveActivity(activityId, revisionId) {
      swal({
        title: "Archiving an activity will remove it from the THREAD library and will no longer allow for the activity to be applied to any studies. Are you sure you want to archive the activity?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b8c7ce",
        cancelButtonColor: "#f16559",
        confirmButtonText: "No",
        cancelButtonText: "Yes"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          this.$emit("changeStatustoArchive", {
            activityId,
            revisionId,
            targetLibrary: this.targetLibrary
          });
        }
      });
    },
    closeActivityVersionsModal() {
      this.$refs.activityVersionsModal.hide();
    },
    getActivityVersions(activityId) {
      this.$api
        .getActivityVersions(activityId, {
          targetLibrary: this.migrationData && this.migrationData.threadLibrary ? this.targetLibrary : ""
        })
        .then(
          response => {
            this.activityRevisions = this.getSortedVersionHistory(response.data.result.rows);
            this.overallactivityRevisionCount = this.activityRevisions.length;
            this.$refs.activityVersionsModal.show();
          },
          () => {
            toastr.error("Error while getting activity versions");
          }
        );
    },
    addToStudyActivities(activity) {
      if (activity.type) {
        const saveForm = {};

        saveForm.label = activity.abbreviation;
        saveForm.s3Key = activity.s3object_key;

        saveForm.fields = null;
        saveForm.studyId = this.studyId;
        saveForm.unscheduledPacketIds = [];
        saveForm.activityId = activity.activityId;
        saveForm.revisionId = activity.revisionId;
        saveForm.type = activity.type;
        saveForm.title = activity.name;
        saveForm.therapeuticArea = activity.therapeuticArea;
        saveForm.therapeuticIndication = activity.therapeuticIndication;
        saveForm.timeToComplete = activity.timeToComplete;
        saveForm.noOfQuestions = activity.stepsCount;

        this.$api.postNewActivityIntoStudy(this.studyId, saveForm).then(
          () => {
            this.$api.updateActivityStudyCount(activity.activityId, activity.revisionId, { studyId: this.studyId }).then(
              () => {
                toastr.success("Activity added successfully to Study");
                this.$router.push({
                  name: "study-activities",
                  params: { studyId: this.studyId }
                });
              },
              error => {
                toastr.error(error.body && error.body.message ? error.body.message : "Error while adding Activity to Study");
              }
            );
          },
          error => {
            toastr.error(error.body && error.body.message ? error.body.message : "Error while adding Activity to Study");
          }
        );
      }
    },
    addActivityToDCF(activity) {
      const saveForm = {};
      saveForm.label = activity.abbreviation;
      saveForm.s3Key = activity.s3object_key;
      const questions = filter(activity.questionAnswer, question => question.type != "Section" && question.type != "SurveyCompletion");
      saveForm.fields = null;
      saveForm.studyId = this.studyId;
      saveForm.unscheduledPacketIds = [];
      saveForm.activityId = activity.activityId;
      saveForm.revisionId = activity.revisionId;
      saveForm.type = activity.type;
      saveForm.name = activity.name;
      saveForm.noOfQuestions = questions.length;

      this.$api.postActivityFormToStudyV3(this.studyId, saveForm).then(
        () => {
          this.$api.updateActivityStudyCount(activity.activityId, activity.revisionId, { studyId: this.studyId }).then(
            () => {
              toastr.success("Activity added successfully to Study");
              this.$router.push({
                name: this.$route.name == "data-capture-form-activity-library" ? "forms-list" : "study-activities",
                params: { studyId: this.studyId }
              });
            },
            error => {
              toastr.error(error.body && error.body.message ? error.body.message : "Error while adding Activity to Study");
            }
          );
        },
        error => {
          toastr.error(error.body && error.body.message ? error.body.message : "Error while adding Activity to Study");
        }
      );
    },
    async addActivityToStudy(activity) {
      const isSiteFacing = await this.determineActivityFacing(activity);
      if (isSiteFacing) {
        this.addActivityToDCF(activity);
      } else {
        if (this.$route.name == "data-capture-form-activity-library") {
          return toastr.error("This is not a site team activity");
        }
        this.addToStudyActivities(activity);
      }
    },
    downloadObjectAsJson(activityId, revisionId) {
      toastr.success("Activity file export in progress. Download will begin momentarily.");
      this.$api.getActivityDetails(activityId, revisionId).then(response => {
        const activityData = response.data.result;
        if (this.migrationData && this.migrationData.threadLibrary) {
          const isMigratedActivity = this.data.some(recordValue => recordValue.targetLibrary == "Thread");
          if (isMigratedActivity) {
            activityData.createdBy = "THREAD";
          }
        }
        const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(activityData));
        const downloadAnchorNode = document.createElement("a");
        downloadAnchorNode.setAttribute("href", dataStr);
        downloadAnchorNode.setAttribute("download", activityData.name + ".json");
        document.body.appendChild(downloadAnchorNode); // required for firefox
        downloadAnchorNode.click();
        downloadAnchorNode.remove();
      });
    },
    exportPdf(activityId, revisionId) {
      this.$router.push({
        name: "activity-export",
        params: { activityId: activityId, revisionId: revisionId }
      });
    },
    getUserProfileDetails() {
      this.$api.getProfileDetails(this.user.id, this.studyId).then(response => {
        this.userProfileData = response.body.activityLibraryAllowed;
      });
    },
    getlibraryAccess() {
      if (this.user.userRole == "StudyAdmin") {
        if (this.userProfileData == false) {
          return "library_none_property";
        }
      }
    },
    openActivityComparator(targetActivity) {
      const sourceActivity = this.activityRevisions.find(activity => {
        return activity.status === "Published";
      });

      this.targetActivityData = {
        activityId: targetActivity.activityId,
        revisionId: targetActivity.revisionId
      };
      this.sourceActivityData = {
        activityId: sourceActivity.activityId,
        revisionId: sourceActivity.revisionId
      };

      this.loadActivityDiff = true;
      this.closeActivityVersionsModal();
      this.$refs.comparatorModal.show();
    },
    closeComparatorModal() {
      this.$refs.comparatorModal.hide();
      this.setDefaultDataForComparator();
    },
    setDefaultDataForComparator() {
      this.sourceActivityData = null;
      this.targetActivityData = null;
      this.loadActivityDiff = false;
    }
  },
  mounted() {
    this.getUserProfileDetails();
    if (this.migrationData && this.migrationData.threadLibrary) {
      this.getActivtyThreadInstances();
    }
    this.hideLanguageCheckBox();
  }
};
</script>

<style lang="scss">
.va-m {
  vertical-align: middle;
}
#activity-library-table__container {
  .popover {
    width: auto !important;
    min-width: 210px;
    margin: 0 !important;
    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.15);
    background-color: #ffffff;
    left: -8px !important;
    border: none;

    .popover-body {
      margin: 0 !important;
      padding: 0 !important;
    }
  }
  .activity-library-table__languages-list {
    padding-right: 10px;
  }

  table {
    tbody {
      tr:hover {
        background-color: rgba(211, 223, 228, 0.5);
      }
    }
  }
}

.width-100 {
  width: 100px !important;
}
</style>

<style scoped lang="scss">
.action-dropdown-menu {
  line-height: 27px;
  font-size: 12px;
  padding: 0.125rem 0.75rem;
  box-shadow: rgba(0, 0, 0, 0.1) 1px 1px 1px 1px;
  min-width: 7rem;
}

.activity-library-table {
  &__container {
    margin: 0 auto;

    .card-body {
      padding: 0;
    }

    .container {
      max-width: 90%;
    }

    .card {
      border: none;
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
    }
  }

  &__chip {
    height: 21px;
    border-radius: 10px;
    background-color: #b0bac9;
    padding: 3px 8px;
    color: #fff;
    font-size: 10px;
    display: inline-block;
    font-family: "RobotoBold";
  }

  &__view-img {
    height: 34px;
    cursor: pointer;
    margin-top: -10px;
  }

  &__action-icon {
    cursor: pointer;
    height: 20px;
  }

  &__collapse-state-text {
    font-size: 12px;
    color: #000000;
    line-height: 2;
    cursor: pointer;
    position: relative;
    bottom: 8px;
  }
  &__pagination {
    margin-top: 25px;
    margin-bottom: 40px;
    margin-left: 25px !important;
  }

  &__empty-pin {
    height: 25px;
  }

  &__language-box {
    width: 35px;
    height: 24px;
    font-size: 14px;
    font-weight: bold;
    color: #4c8ce4;
    border: 1px solid #d3dee3 !important;
    border-radius: 4px;
    text-align: center;
    display: inline-block;
    cursor: pointer;

    &:focus {
      outline: none;
    }
  }

  &__language-pop-over-container {
    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.15);
    background-color: #ffffff;
    overflow-y: scroll;
    max-height: 258px;
    scrollbar-width: thin; /* "auto" or "thin"  */
    scrollbar-color: #e6e9ed transparent; /* scroll thumb & track */

    &::-webkit-scrollbar {
      width: 5px; /* width of the entire scrollbar */
      max-height: 15%;
    }
    &::-webkit-scrollbar-track {
      background: transparent; /* color of the tracking area */
    }
    &::-webkit-scrollbar-thumb {
      background-color: #b0bac9; /* color of the scroll thumb */
      border-radius: 20px; /* roundness of the scroll thumb */
      border: 3px solid transparent; /* creates padding around scroll thumb */
    }
  }

  &__languages-list {
    list-style: none;
    padding-left: 15px;
    padding-top: 9px;
  }

  &__languages-list-item {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.14;
    letter-spacing: normal;
    color: #000000;
  }

  &__expand-arrow {
    width: 18px;
    height: 18px;
    position: relative;
    top: 4px;
    background-color: white;
  }

  &__collapse-arrow {
    width: 18px;
    height: 18px;
    position: relative;
    top: 4px;
    background-color: white;
    transform: rotateX(180deg);
  }
}
.col-lg-5 .activity-library-table__container .container {
  max-width: 98%;
  margin-left: 12%;
}
.cursor-pointer {
  cursor: pointer;
}

.header-title {
  font-size: 16px;
}

.badge-container {
  font-size: 12px;
}
.badge-secondary {
  background-color: #b0bac9;
  position: relative;
  bottom: 3px;
}
.arrow-icon {
  width: 32px;
  height: 32px;
  border-radius: 3px;
  background-color: #ffffff;
  border: solid 1px #e4e8eb;
  text-align: center;
  font-size: 23px;
  line-height: 10px !important;
  color: #e4e8eb;
}

.pagination {
  width: 32px;
  height: 32px;
  border-radius: 3px;
  background-color: #ffffff;
  border: solid 1px #e4e8eb;
  text-align: center;
  font-size: 13px;
  line-height: 23px !important;
  color: #4a4a4a;
  padding-left: 11px !important;
}

.pagination2 {
  width: 46px;
  height: 32px;
  background-color: #ffffff;
  font-size: 13px;
  line-height: 23px !important;
  color: #4a4a4a;
  padding-left: 6px !important;
}

.disabledPagination {
  pointer-events: none;
}

.settings-dropdown-item {
  line-height: 27px;
  font-size: 12px;
  padding: 0.125rem 0.75rem;
  cursor: pointer;
}
.dropdown-submenu {
  position: relative;
}
.dropdown-submenu > .dropdown-menu {
  top: 0;
  left: -144%;
  margin-top: -6px;
  margin-left: -1px;
  -webkit-border-radius: 0 6px 6px 6px;
  -moz-border-radius: 0 6px 6px;
  border-radius: 0 6px 6px 6px;
}
.dropdown-submenu .file {
  left: -91% !important;
}
.dropdown-submenu:hover > .dropdown-menu {
  display: block;
}
.dropdown-submenu:hover > a:after {
  border-left-color: #fff;
}
.dropdown-submenu.pull-left {
  float: none;
}
.dropdown-submenu.pull-left > .dropdown-menu {
  left: -100%;
  margin-left: 10px;
  -webkit-border-radius: 6px 0 6px 6px;
  -moz-border-radius: 6px 0 6px 6px;
  border-radius: 6px 0 6px 6px;
}
.dropleft .dropdown-toggle::before {
  border-right: 0 !important;

  transform: rotate(45deg);
  background-color: #4c8ce4;
}
.export_img {
  margin-left: -10px;
  height: 13px;
  margin-top: 12px;
}
.versions-modal {
  position: absolute;
  z-index: 1040;
}
.versions-modal .table thead th {
  color: #b0bac9;
  font-weight: normal;
  font-family: Roboto-Medium;
  border-bottom: 1px solid #dee2e6;
}
.versions-modal .table tbody th {
  color: #000;
  font-weight: normal;
  font-family: Roboto-Medium;
}
.versions-modal .table tbody tr th {
  max-width: 450px;
}
.versions-modal .table tbody tr td:nth-child(2) {
  width: 250px;
}
.versions-modal .table tbody tr td:nth-child(3) {
  width: 250px;
}

.versions-modal .table tbody tr td:last-child {
  width: 230px;
}
.versions-modal .table .table-bordered .btn {
  font-size: 12px;
  padding: 0.1rem 0.5rem;
  background: #fff;
  border: 1px solid #ced4da;
  color: #4c8ce4;
}
.versions-modal .close-icon {
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;
}
.tag2_div {
  max-width: 85%;
  overflow: hidden;
}
.plus_div {
  width: 10%;
  padding: 0 5px;
}
.version_heading {
  color: #666669;
  font-size: 16px;
  font-weight: bold;
}
.library_none_property {
  display: none;
}

tbody.tbody\.table-scroller {
  height: auto !important;
  border: 1px solid #ced4da;
  border-top: none !important;
}
tbody.versions-modal.\.table.tbody {
  height: 500px !important;
  position: unset !important;
  border: 1px solid #ced4da;
  border-top: none !important;
}
.versions-modal .table tbody {
  display: block;
  height: 500px;
  overflow: auto;
}
.versions-modal .table thead {
  display: block;
}
.versions-modal .table thead,
.versions-modal .table tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}
.versions-modal .table tbody tr th {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6 !important;
  border-bottom: none !important;
  color: #666769 !important;
}
th.border-top-0.version_width {
  width: 110px !important;
}
@media (min-width: 1024px) and (max-width: 1199px) {
  th.border-top-0.version_width {
    width: 80px !important;
  }
  .versions-modal .table tbody tr th {
    max-width: 80px;
  }
  .versions-modal .table tbody tr td:nth-child(2) {
    width: 180px;
  }
  .versions-modal .table tbody tr td:nth-child(3) {
    width: 180px;
  }
  .versions-modal .table tbody tr td:last-child {
    width: 200px;
  }
  .activity-comparator {
    .modal {
      .modal-header {
        .close {
          opacity: 1;
          padding: 0.75rem 0.75rem 1rem 1rem;
        }
      }
    }
  }
}
#showCheckboxesInstance {
  background: #fff;
  position: relative;
  width: 100%;
  max-height: 301px;
  border-radius: 3px;
  padding: 10px;
  z-index: 3;
  -webkit-box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
  overflow-y: scroll;
  top: -8px;
}
.activity-builder-select-options {
  overflow: scroll;
  top: 0;
}
.select-scroll {
  scrollbar-width: thin;
  scrollbar-color: #e6e9ed transparent;
}
.language-search-bar {
  width: 181px;
  height: 33px;
  border-radius: 4px;
  border: solid 1px #b0bac9;
  background-color: #ffffff;
}
.check_label_input input {
  float: left;
  line-height: 30px;
  margin-top: 0px;
  -webkit-margin-before: 8px;
}
#showCheckboxesInstance label {
  font-size: 14px;
  color: #000;
  margin-left: 8px;
  float: left;
  width: 275px;
  line-height: 30px;
  white-space: nowrap;
  margin-bottom: 0;
}
.filter-form-box .activity-type-select {
  width: 100%;
  font-size: 12px;
  border: none;
  height: 35px;
  background-color: #ffff;
  color: #666669;
  border-radius: 4px;
  border: solid 1px #4c8ce4;
}
.migratebtn {
  width: 102px;
  height: 34px;
  gap: 10px;
  margin: 20px 0 0 302px;
  padding: 4px 27px;
  border-radius: 18px;
  background-color: #e0e0e0;
  float: right;
  text-align: center;
  color: #4a4a4a;
  border: none;
  cursor: pointer;
}
.search-instance {
  top: -35px;
}
.search-instance .language-search-bar {
  width: 100%;
  padding: 5px 10px;
  margin-bottom: 10px;
}
.search-instance .language-search-bar:focus {
  border: solid 1px #4c8ce4;
}

.search-instance .check_label_input {
  padding: 0 10px;
}
#select-instance {
  width: 518px;
}
.input {
  position: relative;
  width: 100%;
}
.input__label {
  position: absolute;
  left: 8px;
  top: 8px;
  padding: calc(var(--size-bezel) * 0.75) calc(var(--size-bezel) * 0.5);
  margin: calc(var(--size-bezel) * 0.75 + 3px) calc(var(--size-bezel) * 0.5);
  white-space: nowrap;
  transform: translate(0, 0);
  transform-origin: 0 0;
  background: #fff;
  transition: transform 120ms ease-in;
  line-height: 1.2;
  z-index: 0;
}
.input__field {
  box-sizing: border-box;
  display: block;
  width: 100%;
  border: 3px solid currentColor;
  padding: calc(var(--size-bezel) * 1.5) var(--size-bezel);
  color: currentColor;
  background: transparent;
  border-radius: var(--size-radius);
  padding-left: 10px;
  position: relative;
  z-index: 99;
}
.input__field:not(:-moz-placeholder-shown) + .input__label {
  transform: translate(0.25rem, -65%) scale(0.8);
  color: var(--color-accent);
}
.input__field:not(:-ms-input-placeholder) + .input__label {
  transform: translate(0.25rem, -65%) scale(0.8);
  color: var(--color-accent);
}
.input__field:focus + .input__label,
.input__field:not(:placeholder-shown) + .input__label {
  transform: translate(0.25rem, -65%) scale(0.8);
  color: #4c8ce4;
  top: 4px;
  z-index: 101;
}
</style>
